function DetailsHeading(props) {
    return (
        <h1 className="details-heading">{props.text}</h1>
    );
}

export default DetailsHeading;